import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../../services/auth.service';
import { MemberService } from './../../../../rest/api/member.service';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageComponent implements OnInit {
  accessToken: any;

  userData: any;
  vrLinksEnabled: any;
  loader = true;
  constructor(
    private authService: AuthService,
    public memberService: MemberService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.authService.membersDataSubscription.subscribe(response => {
      if (response) {
        this.userData = response;
        this.vrLinksEnabled = this.userData.vr_enabled ? true : false;
        setTimeout(() => {
          this.loader = false;
        }, 500);
      }
    });
  }

  changeVrLinks() {
    this.memberService.enableDisableVrLinks(this.accessToken).subscribe((response: any) => {
      this.vrLinksEnabled = response && response.data && response.data.vr_enabled ? response.data.vr_enabled : false;
    }, err => {
      this.vrLinksEnabled = this.userData.vr_enabled ? true : false;
    });
  }
}
